import img from "../../../img/life.svg";
import img2 from "../../../img/bag.svg";
import img3 from "../../../img/surface.svg";
import img4 from "../../../img/loan.svg";
import img5 from "../../../img/bag2.svg";
import img6 from "../../../img/invests.svg";
import img7 from "../../../img/users.svg";

export const service = [
  {
    img: img,
    title: "Life Insurance",
    price: "Unlimited protection",
    bg: "rgb(231, 237, 255)",
  },
  {
    img: img2,
    title: "Shopping",
    price: "Buy. Think. Grow.",
    bg: "rgb(255, 245, 217)",
  },
  {
    img: img3,
    title: "Safety",
    price: "We are your allies",
    bg: "rgb(220, 250, 248)",
  },
];
export const serviceTable = [
  {
    img: img4,
    title1: "Business loans",
    title: "Lorem Ipsum",
    text1: "It is a long established",
    text: "Many publishing",
    button: "View Details",
    bg: "rgb(255, 224, 235)",
  },
  {
    img: img5,
    title1: "Checking accounts",
    title: "Lorem Ipsum",
    text1: "It is a long established",
    text: "Many publishing",
    button: "View Details",
    bg: "rgb(255, 245, 217)",
  },
  {
    img: img6,
    title1: "Savings accounts",
    title: "Lorem Ipsum",
    text1: "It is a long established",
    text: "Many publishing",
    button: "View Details",
    bg: "rgb(255, 224, 235)",
  },
  {
    img: img7,
    title1: "Debit and credit cards",
    title: "Lorem Ipsum",
    text1: "It is a long established",
    text: "Many publishing",
    button: "View Details",
    bg: "rgb(231, 237, 255)",
  },
  {
    img: img3,
    title1: "Life Insurance",
    title: "Lorem Ipsum",
    text1: "It is a long established",
    text: "Many publishing",
    button: "View Details",
    bg: "rgb(220, 250, 248)",
  },
  {
    img: img4,
    title1: "Business loans",
    title: "Lorem Ipsum",
    text1: "It is a long established",
    text: "Many publishing",
    button: "View Details",
    bg: "rgb(255, 224, 235)",
  },
];
